__turbopack_context__.v({
  "earthVideoFade": "LandingEarthPeek-module-scss-module__WN3ZXG__earthVideoFade",
  "mediaFrame": "LandingEarthPeek-module-scss-module__WN3ZXG__mediaFrame",
  "poster": "LandingEarthPeek-module-scss-module__WN3ZXG__poster",
  "root": "LandingEarthPeek-module-scss-module__WN3ZXG__root",
  "video": "LandingEarthPeek-module-scss-module__WN3ZXG__video",
});
